module.exports = __webpack_public_path__ + "static/img/2@2x.c6bc9d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/v17_new_features/2@2x.png
// module id = zpze
// module chunks = 0